/* eslint-disable react/function-component-definition */
import { GridItem } from '@tvg/fuse/grid';
import classNames from 'classnames';
import React from 'react';
import styles from './Recs.module.css';

export interface RecsGridItemProps {
  lastOfType?: boolean;
}

export const RecsGridItem: React.FC<RecsGridItemProps> = ({ lastOfType: lastRec }) => (
  <GridItem
    data-testid="gallery-recs-container"
    className={classNames(styles.recsContainer, 'grid-item grid-item--recs-container grid-item--hidden', {
      'grid-item--recs-container-last': lastRec,
    })}
  />
);
